/*
 * 입력값 검증. 구 String.prototype.isName / isPhone 대체.
 */

/** 구 isName — 1글자 이상 */
export const isValidName = (value: string | null | undefined): boolean => {
  return (value?.length ?? 0) >= 1
}

/** 구 isPhone — 숫자만 남긴 뒤 국내 휴대전화 패턴(10~11자리) 검사 */
export const isValidPhone = (value: string | null | undefined): boolean => {
  if (value === null || value === undefined) {
    return false
  }
  const digits = String(value).replace(/[^0-9]/g, '')
  if (digits.length === 10) {
    return /^(010|011|016|017|019)[0-9]{3}[0-9]{4}$/.test(digits)
  }
  if (digits.length === 11) {
    return /^(010|011|016|017|019)[0-9]{4}[0-9]{4}$/.test(digits)
  }
  return false
}
